const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the manager assignment component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerAssignment', ['Application', 'Authorization', 'Managers', 'UserTracks', 'Assignments', 'AnalyzeManager', '$translate', function (Application, Authorization, Managers, UserTracks, Assignments, AnalyzeManager, $translate) {
  return {
    restrict: 'E',
    scope: {
      tab: '=',
      manager: '=',
      assignmentId: '=',
      assignmentContent: '=',
      assignmentType: '=',
      userList: '=',
      managerConfiguration: '=?'
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-assignment.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.translations = {};
            // Disable specific to manager configuration
      if ($scope.manager && $scope.managerConfiguration) {
        if ($scope.managerConfiguration.disable_assignment_completion) {
          self.disableCompletion = true;
        }
        if ($scope.managerConfiguration.disable_assignment_removal) {
          self.disableRemoval = true;
        }
        if ($scope.managerConfiguration.disable_assignment_edit) {
          self.disableEdit = true;
        }
      }

      self.information = {
        content: null,
        assignments: [],
        contentType: null,
        courses: {},
        courseCount: 0,
        userCompleted: {},
        reminders: {},
        searching: false,
        page: 1,
        per_page: 10,
        opts: null,
        nextPage: function () {
          if (this.assignments.length < this.per_page) {
            return;
          }
          this.page++;
          this.get(self.information.opts || null);
        },
        previousPage: function () {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.get(self.information.opts || null);
        },
        get: function(opts) {
          self.circles.get();
          self.information.reminders = {};
          self.information.searching = false;

          var query = {
            subresource: $scope.manager._id,
            page: self.information.page,
            per_page: self.information.per_page,
            content: $scope.assignmentContent,
            type: $scope.assignmentType,
            sort: 'completed_date,1'
          };

          var body = {
            manager_query: true,
            queries: []
          };

          if (opts) {
            body.queries = [opts];
            self.information.opts = opts;
          } else {
            self.information.opts = null;
          }

          if (body.queries && body.queries.length) {
            self.information.searching = true;
          }

          Managers.assignments(query, body).$promise.then(function(data) {
            self.information.content = data.content;
            if ($scope.assignmentType === 'track') {
              self.information.getUserTracks(data.assignments);
            }

            data.assignments.forEach(function(item) {
              if (!item.completed_date && item.due_date && new Date() > new Date(item.due_date)) {
                item.overdue = true;
              }
            });

            self.information.assignments = data.assignments;
            self.information.contentType = data.content && data.content.type ? data.content.type : $scope.assignmentType;
            self.information.contentType = self.information.contentType.charAt(0).toUpperCase() + self.information.contentType.slice(1);
            self.information.contentType = self.information.contentType === 'Track' ? 'Learning Track' : self.information.contentType;
          }).catch(function(error) {
            // handle error
            console.log('Error in manager assignments: ', error);
          });
        },
        getUserTracks: function(assignments) {
          self.information.courseCount = 0;
          self.information.courses = {};
          self.information.userCompleted = {};
          var users = assignments.map(function(item) {
            return item.user._id;
          });
          UserTracks.find({
            user: '$in,' + users.length + ',' + users.join(','),
            track: $scope.assignmentContent,
            fields: 'user,track,completed_media,completed_articles,completed_quizzes,completed_assessments,completed_scorm'
          }).$promise.then(function(userTracks) {
            self.information.content.sections.forEach(function(section) {
              section.courses.forEach(function(course) {
                if (course.article) {
                  self.information.courses[course.article] = true;
                }
                if (course.video) {
                  self.information.courses[course.video] = true;
                }
                if (course.file) {
                  self.information.courses[course.file] = true;
                }
                if (course.quiz) {
                  self.information.courses[course.quiz] = true;
                }
                if (course.scorm) {
                  self.information.courses[course.scorm] = true;
                }
                if (course.assessment) {
                  self.information.courses[course.assessment] = true;
                }
                self.information.courseCount++;
              });
            });
            userTracks.forEach(function(item) {
              var completed = 0;
              var items = [].concat(item.completed_media, item.completed_articles, item.completed_quizzes, item.completed_scorm, item.completed_assessments);
              for (var i = 0; i < items.length; i++) {
                if (self.information.courses[items[i]]) {
                  completed++;
                }
              }
              self.information.userCompleted[item.user] = Math.floor(completed / self.information.courseCount * 100);
            });
          });
        }
      };

      self.circles = {
        comments: 0,
        likes: 0,
        shares: 0,
        views: 0,
        user_list: [],
        get: function() {
          if (!$scope.userList) {
            return;
          }
          AnalyzeManager.content({itemid: $scope.assignmentContent, user_list: $scope.userList}).$promise
          .then(function(data) {
            self.circles.likes = data.likes;
            self.circles.shares = data.shares;
            self.circles.views = data.views;
            self.circles.comments = data.comments;
          });
        }
      };

      self.search = {
        managerQuery: true,
        restrictions: {manager_email: $scope.manager.email},
        get: function(opts) {
          self.information.page = 1;
          self.information.get(opts);
        }
      };

      self.sendReminder = function(item) {
        Assignments.remind({remindid: item._id}, null).$promise
        .then(function() {
          $translate('managerAssignment.reminder_sent', {name: item.user.full_name }).then(function (translation) {
            Application.messaging.addMessage({type: 'success', text: translation, duration: 5});
          });
          self.information.reminders[item._id] = true;
        });
      };

      self.assignmentRemoval = {
        active: null,
        set: function(assignment) {
          this.active = assignment;
        },
        onDelete: function() {
          this.active = null;
          self.information.get(self.information.opts || null);
        }
      };

      $scope.$watch('assignmentContent', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.csvLink = Application.API + '/learn/v3/managers/' + $scope.manager._id + '/assignment-report/' + $scope.assignmentType + '/' + $scope.assignmentContent +  '?authtoken=' + Authorization.getAuthToken().authtoken
          self.information.page = 1;
          self.information.get();
        }
      });

      $scope.$watch('manager', function(newVal, oldVal) {
        self.search.restrictions['manager_email'] = $scope.manager.email;
      }, true);

      self.setTranslations = function(){
        $translate([
          'global.label.views',
          'global.label.comments',
          'global.label.likes',
          'global.label.shares',
          'managerAssignment.byYourTeamForThisContent'
        ]).then(function (translations) {
          self.translations = translations
        })
      }
    }],
    controllerAs: 'assigned'
  };
}]);
